module.exports = __webpack_public_path__ + "static/media/fanta-checkmark.978026d3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fanta-checkmark.svg
// module id = 5290
// module chunks = 11